"use strict";
import { jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import Api from "../api/api";
import { push } from "./app_history";
function RootPage() {
  const redirected = useRef(false);
  useEffect(() => {
    if (redirected.current) return;
    redirected.current = true;
    if (Api.Account.current().scraper_account && Api.Account.current().payables_account) {
      push("/dashboard");
    } else if (Api.Account.current().scraper_account) {
      push("/to_be_scraped_loads");
    } else {
      push("/dashboard");
    }
  }, []);
  return /* @__PURE__ */ jsx("span", { "data-component": "RootPage" });
}
export default RootPage;
